import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ProduktvalTableComponent } from "./produktval-table/produktval-table.component";
import { ProduktvalComponent } from "./produktval.component";

@NgModule({
    exports: [ProduktvalComponent],
    imports: [
        RaskCommonModule,
        ProduktvalComponent,
        ProduktvalTableComponent
    ],
    providers: []
})

export class ProduktvalModule { }
